import React from 'react';
import PageView from '../components/sections/PageView';

const PrivateEventsPage = () => <PageView slug="private_events" />;

export default PrivateEventsPage;
